module.exports = __webpack_public_path__ + "img/bg-sect-2.d5196898.png";